import { render } from "./FrInput.vue?vue&type=template&id=3212c8b6&scoped=true"
import script from "./FrInput.vue?vue&type=script&lang=js"
export * from "./FrInput.vue?vue&type=script&lang=js"

import "./FrInput.vue?vue&type=style&index=0&id=3212c8b6&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3212c8b6"]])

export default __exports__